import {Component} from '@angular/core';
import {ButtonComponent} from "../../../../shared/components/button/button.component";

@Component({
    selector: 'wci-about',
    imports: [
        ButtonComponent
    ],
    templateUrl: './about.component.html',
    styles: ``,
})
export class AboutComponent {}
